import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useNotifications } from 'src/utils/hooks';
import { AUTO_GENERATE_SITE_DOCS_MUTATION } from './auto-generate-site-docs.operations';
import {
  AutoGenerateSiteDocsInput,
  AutoGenerateSiteDocsResponse,
} from './auto-generate-site-docs.types';

export const useAutoGenerateSiteDocs = () => {
  const { showErrorAlert } = useNotifications();

  const [autoGenerateSiteDocsMutation, isLoading] = useMutation<AutoGenerateSiteDocsResponse>(
    AUTO_GENERATE_SITE_DOCS_MUTATION,
    {
      onError: (error) => {
        console.error(error);
        showErrorAlert('Something went wrong auto-generating site docs, please try again');
      },
    },
  );

  const autoGenerateSiteDocs = useCallback(
    async (params: AutoGenerateSiteDocsInput) => {
      const result = await autoGenerateSiteDocsMutation({ variables: { params } });

      if (result && !!result.data) {
        return result.data.autogenerateSiteDocs;
      }
      return null;
    },
    [autoGenerateSiteDocsMutation],
  );

  return { autoGenerateSiteDocs, isLoading };
};
